if (!customElements.get('product-quick-buy-mobile')) {
  customElements.define(
    'product-quick-buy-mobile',
    // eslint-disable-next-line no-undef
    class ProductQuickBuyMobile extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.state = {
          productHandle: '',
          productOptionHTML: {},
          trackingInformation: {},
        }
      }

      setupListeners () {
        super.setupListeners()

        this.addEventListener('click', event => {
          event.stopPropagation()
        })

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.MOBILE_QUICK_BUY.OPENED,
          this.renderProductForm.bind(this),
        )

        this.listeners.add(
          this.els.overlay.element,
          'click',
          this.handleClose.bind(this),
        )

        if (this.externalEls.submit) {
          this.listeners.add(
            this.externalEls.submit.element,
            'click',
            this.handleClose.bind(this),
          )
        }
      }

      handleFormSubmit (event) {
        if (
          event.target.hasAttribute('data-product-drawer-external-el') &&
          event.target.getAttribute('data-product-drawer-external-el') ===
            'quickbuy-product-form'
        ) {
          window._previousFocus = document.querySelector(
            `[data-product-card-el="mobileTrigger"][data-product-handle="${event.target.dataset.productHandle}"]`,
          )
        }

        this.addToCartNostoTracking()
        this.handleClose()
      }

      addToCartNostoTracking () {
        if (this.state.trackingInformation.source === 'autocomplete') {
          window.theme.autocomplete.eventBus.publish(
            window.theme.autocomplete.events.TRACKING.PRODUCT_ADDED_TO_CART,
            {
              hit: {
                productId: this.state.trackingInformation.product.productId,
                productUrl: this.state.trackingInformation.product.url,
              },
              type: 'autocomplete',
            },
          )
        }

        if (
          this.state.trackingInformation.source === 'serp' ||
          this.state.trackingInformation.source === 'category'
        ) {
          window.theme.results.eventBus.publish(
            window.theme.results.events.TRACKING.PRODUCT_ADDED_TO_CART,
            {
              hit: {
                productId: this.state.trackingInformation.product.productId,
                productUrl: this.state.trackingInformation.product.url,
              },
              type: this.state.trackingInformation.source,
            },
          )
        }
      }

      async renderProductForm (event) {
        this.state.productHandle = event.detail.productHandle
        this.state.trackingInformation = event.detail.trackingInformation

        window.BAO.dispatchEvent(window.BAO.EVENTS.QUICKBUY.BEFORE_OPTIONS_LOAD)

        if (!this.state.productOptionHTML[this.state.productHandle]) {
          this.state.productOptionHTML[
            this.state.productHandle
          ] = await this.fetchProductOptionsHTML()
        }

        this.els.container.element.innerHTML = this.state.productOptionHTML[
          this.state.productHandle
        ]

        if (this.querySelector('form')) {
          this.querySelector('form').addEventListener(
            'submit',
            this.handleFormSubmit.bind(this),
          )
        }

        this.handleOpen()

        // eslint-disable-next-line no-undef
        trapFocus(this.els.container.element)
      }

      async fetchProductOptionsHTML () {
        return await fetch(
          `${window.Shopify.routes.root}products/${this.state.productHandle}?section_id=${this.sectionId}`,
        )
          .then(response => response.text())
          .then(responseText => {
            return responseText
          })
      }

      handleClose () {
        this.els.container.element.setAttribute('aria-hidden', true)
        this.els.container.element.removeAttribute('data-mode')
      }

      handleOpen () {
        this.els.container.element.setAttribute('aria-hidden', false)
        this.els.container.element.setAttribute('data-mode', 'open')
      }

      get sectionId () {
        return 'product-quickbuy'
      }
    },
  )
}
